import { Text } from 'basic-ui-lib/components/Text';
import { Colors } from 'basic-ui-lib/constants';
import styled from 'styled-components';

export interface ItemMenuProps {
  key?: string;
  icon?: React.ReactNode;
  title?: string;
  onClick?: () => void;
}

const ItemMenu = ({ icon, title, onClick }: ItemMenuProps) => {
  return (
    <Container onClick={onClick}>
      {icon && <>{icon}</>}
      <Text body_1 regular>
        {title}
      </Text>
    </Container>
  );
};

export default ItemMenu;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;
  background-color: ${Colors.neutral.bg[1]};
  cursor: pointer;

  &:hover {
    background-color: ${Colors.neutral.bg[3]};
  }
`;
